import { useEffect, useState } from "react";

import { Typography } from "@king-ict/eupisi-ui/components";
import { hrDate } from "@king-ict/eupisi-ui/utils";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import ChildData from "../../../models/Integration/ChildData";

interface ChildrenOfParentsCriterionDataProps {
  data: string;
}

export default function ChildrenOfParentsCriterionData({
  data,
}: ChildrenOfParentsCriterionDataProps) {
  const { t } = useTranslation();

  const [children, setChildren] = useState<ChildData[]>([]);

  useEffect(() => {
    var childrenOfParents: ChildData[] = JSON.parse(data);
    setChildren(childrenOfParents);
  }, [data]);

  return (
    <>
      <Row>
        {children &&
          children.map((child) => {
            return (
              <Col md={12}>
                <Typography component="p" variant="baseBold">
                  {t("criteriaStep.child")}: {child.ChildCounter}
                </Typography>

                <Typography component="p" variant="base">
                  {t("person.firstName")}: {child.FirstName}
                </Typography>

                <Typography component="p" variant="base">
                  {t("person.lastName")}: {child.LastName}
                </Typography>

                <Typography component="p" variant="base">
                  {t("person.oib")}: {child.Oib}
                </Typography>

                <Typography component="p" variant="base">
                  {t("person.dateOfBirth")}: {hrDate(child.DateOfBirth)}
                </Typography>
              </Col>
            );
          })}
      </Row>
    </>
  );
}
